const scopes = state => state.scopes

export default {
  scopes
}
